import { translateText as t } from 'utils/i18n';
import { I18N_PLATFORM_COMMON_WORD_PATH } from 'constants/i18n';
const cbsa = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.cbsa`);
const county = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.county`);
const state = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.state`);
const censusTract = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.censusTract`);
const automatic = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.automatic`);
const blockGroup = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.blockGroup`);
const marketOffice = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.marketOffice`);
const submarketOffice = t(`${I18N_PLATFORM_COMMON_WORD_PATH}.submarketOffice`);
const micromarketOffice = t(
  `${I18N_PLATFORM_COMMON_WORD_PATH}.micromarketOffice`,
);
const marketIndustrial = t(
  `${I18N_PLATFORM_COMMON_WORD_PATH}.marketIndustrial`,
);
const submarketIndustrial = t(
  `${I18N_PLATFORM_COMMON_WORD_PATH}.submarketIndustrial`,
);
const micromarketIndustrial = t(
  `${I18N_PLATFORM_COMMON_WORD_PATH}.micromarketIndustrial`,
);
export enum SearchInputSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum SuggestionIcon {
  propertyIcon = 'property',
  companyIcon = 'company',
  dynamicIcon = 'company-property',
  mapBoxAddress = 'mapbox-address',
  globalBoundary = 'globalBoundary',
}

export const GeohierarchyLevelToCountry = {
  stat1: cbsa,
  stat2: county,
  stat3: censusTract,
  adm1: state,
  adm2: county,
  adm3: censusTract,
  adm4: blockGroup,
  auto: automatic,
  ayoff1: marketOffice,
  ayoff2: submarketOffice,
  ayoff3: micromarketOffice,
  ayind1: marketIndustrial,
  ayind2: submarketIndustrial,
  ayind3: micromarketIndustrial,
};
